module.exports = __webpack_public_path__ + "static/media/thumbnail.95a90f6f.jpg";